// extracted by mini-css-extract-plugin
module.exports = {"frame":"App_frame__3mVV6"};